import React, { useState } from 'react';
import './styles.css'; 
import './index.css'; 
import './App.css'; 
import Footer from './Footer';

const About = () => {
  const [videoLoaded, setVideoLoaded] = useState(false);

  const handleVideoLoad = () => {
    setVideoLoaded(true);
  };

  return (
    <div className='max-container about-page flex flex-col items-center justify-center'>
      <section className='mb-3'>

        <h1 className='head-text text-white text-center'>
          {' '}
          {/* <span className='blue-gradient_text drop-shadow font-semibold'>About Me</span> */}
          <span className='blue-gradient_text drop-shadow font-semibold'>"Simply Create"</span>
        </h1>

        {/* <p className='text-slate-400 text-center leading-relaxed'> 
        "Simply Create"
        </p> */}
        <p className='text-slate-400 text-center leading-relaxed'> 
          I am a passionate creator who loves to explore the world of technology and design. My journey has been fueled by a desire to innovate and inspire others through my work. I believe in the power of creativity to transform ideas into reality, and I strive to bring that philosophy to every project I undertake.
        </p>
      </section>

      <div className='mt-1 max-w-full overflow-auto'>
        <div className='video-container rounded-lg overflow-hidden'>
          <video
            autoPlay
            controls
            width={videoLoaded ? '100%' : '1080'} // Initial width: 640px (or adjust as needed)
            height='auto'
            loop
            muted
            onLoadedData={handleVideoLoad} // Callback when video data is loaded
          >
            <source src='/video/SquadaDemoReel.mp4' type='video/mp4' />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;